<template>
  <table-component
    ref="totalMacrosTable"
    :data="items"
    :show-caption="false"
    class="datatable"
    sort-by="name"
    sort-order="asc"
    :show-filter="false">

    <table-column
      show="name"
      :label="''"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      show="carbs"
      :label="$t('health.nutritionalPlan.carbs')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      show="proteins"
      :label="$t('health.nutritionalPlan.protein')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      show="fats"
      :label="$t('health.nutritionalPlan.fat')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      show="calories"
      :label="$t('health.nutritionalPlan.calories')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

  </table-component>
</template>
<script>
import TableColumn from '@/components/shared/table/components/TableColumn';
import TableComponent from '@/components/shared/table/components/TableComponent';
export default {
  name: 'TotalMacrosTable',
  components: {
    TableComponent,
    TableColumn
  },
  props: {
    items: {
      default: []
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/TotalMacrosTable.vue